import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles } from "@material-ui/core";
import { LabledMultilineTextField } from "../core/LabledMultilineTextField";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const ModificationReasonForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_REASON>();
    return (
        <Fragment>
            <h3 className={classes.h3} style={{ marginTop: 28, marginBottom: 16 }}>
                Begründung
            </h3>

            <p className={classes2.pText} style={{ marginTop: 0, marginBottom: 24 }}>
                Bitte beschreiben Sie kurz den Grund für die gewünschte Maßnahme
            </p>
            <LabledMultilineTextField
                placeholder="Ihre Anmerkungen"
                margin="none"
                inputProps={{
                    maxLength: 1000,
                }}
                value={values.modificationReason.value.text || ""}
                onChange={event => {
                    setValues(values => {
                        values.modificationReason.value.text = event.target.value || null;
                    });
                }}
                error={values.modificationReason.error !== null}
            />
        </Fragment>
    );
};
